import * as React from "react";
import { styled } from "styled-components";
import { useMemo, useState } from "react";
import AccordionContext from "./AccordionContext";
import { IconTextButton } from "../Text/IconTextButton";
import Collapse from "../../icons/Collapse";
import Expand from "../../icons/Expand";
import idGenerator from "../../utils/idGenerator";
const StyledAccordion = styled.div `
  width: 100%;
`;
const AccordionActions = styled.div `
  display: flex;
  justify-content: flex-end;
`;
export const Accordion = ({ children, id, openedItems, showToggleAllButton, accordionItemIds = [], onToggle, onToggleAll, variant, onChange, value, values, texts = {
    expandAllText: "Expand all",
    hideAllText: "Collapse all",
}, }) => {
    const [accordionId] = useState(() => id ?? idGenerator("fjordline-accordion-"));
    const toggleAll = () => {
        if (onToggleAll) {
            onToggleAll(openedItems?.length === accordionItemIds?.length ? [] : accordionItemIds);
        }
    };
    const toggleAllIcon = openedItems?.length === accordionItemIds?.length ? Collapse : Expand;
    const toggleButtonText = openedItems?.length === accordionItemIds?.length
        ? texts.hideAllText
        : texts.expandAllText;
    const accordionValue = useMemo(() => ({
        accordionId,
        variant,
        openedItems: openedItems || [],
        onToggle,
        onChange,
        value,
        values: values || [],
    }), [accordionId, onChange, onToggle, openedItems, value, values, variant]);
    return (React.createElement(StyledAccordion, null,
        React.createElement(AccordionContext.Provider, { value: accordionValue },
            showToggleAllButton && (React.createElement(AccordionActions, null,
                React.createElement(IconTextButton, { title: toggleButtonText, onClick: toggleAll, icon: toggleAllIcon }, toggleButtonText))),
            children)));
};
export default Accordion;
//# sourceMappingURL=Accordion.js.map